// extracted by mini-css-extract-plugin
export default {"tupacGrid":"sm-z","tupacHeader":"tm-z","tupacHeader2":"um-z","tupacMenu":"vm-z","tupacMenu2":"wm-z","tupacMain":"xm-z","tupacMain2":"ym-z"};